import { forwardRef } from "react";
import { WidgetProps, WidgetRef } from "../../../types/widget";
import { useDashboardStore, useThemeStore } from "../../../stores";
import { styles } from "../styles";
import { Row, ScrollRow } from "../../containers";
import { JustifyContent, Wrap } from "../../containers/types";
import ActivityRenderer from "../../activity";
import { ActivityRendererType } from "../../activity/types";
import { Heading } from "../../typography";
import { useWidgetFetch } from "../../../hooks";
import { ActivityApi } from "../../../api";
import { getRangeToday } from "../../../utils";

const ActivityWidget = forwardRef<WidgetRef, WidgetProps>((props, ref) => {
  const theme = useThemeStore((s) => s.theme);
  const activities = useDashboardStore((s) => s.activities);
  const setActivitiesFetched = useDashboardStore((s) => s.setActivitiesFetched);

  useWidgetFetch(
    useDashboardStore((s) => s.setActivities),
    () =>
      ActivityApi.getInRange({
        from: getRangeToday().from,
        to: getRangeToday().to,
      }),
    activities,
    () => {
      setActivitiesFetched(true);
    }
  );

  return (
    <div
      ref={ref}
      style={{
        background: theme.overlay,
        position: "relative",
        ...styles.container,
      }}
    >
      <Row style={{ width: "100%" }} justifyContent={JustifyContent.Between}>
        <Heading size={20} color={theme.textOnOverlay}>
          رویداد های امروز
        </Heading>
      </Row>

      {!activities.length ? (
        <Heading
          textStyles={{
            position: "absolute",
            left: "50%",
            top: "50%",
            transform: "translate(-50%, -50%)",
          }}
          color={theme.textOnOverlay}
        >
          رویدادی ثبت نشده!
        </Heading>
      ) : (
        <></>
      )}

      <ScrollRow
        gap={20}
        flexWrap={Wrap.Wrap}
        style={{ width: "100%" }}
        height={300}
      >
        {activities.map((activity, idx) => (
          <ActivityRenderer
            key={idx}
            activity={activity}
            type={ActivityRendererType.Small}
          />
        ))}
      </ScrollRow>
    </div>
  );
});

export default ActivityWidget;
